var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control new-design phone-icon",attrs:{"type":"text","required":_vm.required,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }